import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../services/common/authentication.service";
import { catchError, finalize, map, Observable, throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { StorageKey, StorageService } from "../services/common/storage.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiUrlHelper } from "../services/api-url-helper/api-url-helper";
import { CookieService } from "../services/cookieService/cookie.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private activeRequests = 0;

  constructor(
    private router: Router,
    private storage: StorageService,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private urls: ApiUrlHelper,
    private cookie: CookieService
  ) { }

  // Add partial or full URLs to this list
  byPassURLs: string[] = [
    this.urls.apiUrl.common.getColumnData,
    this.urls.apiUrl.notification.getNotificationList
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authToken = this.storage.getValue(StorageKey.authToken);
    const lang = this.cookie.get("selectedLanguage") || 'eng';

    // Add headers
    let headers = req.headers
      .set('X-Accept-Language', lang)
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('Expires', '0');

    // Add Authorization Token
    if (authToken && this.authService.isTokenValid()) {
      if (!req.url.includes("https://ipapi.co/json")) {
        headers = headers.set('Authorization', 'Bearer ' + authToken);
      }
    }

    const clonedReq = req.clone({ headers });

    const shouldBypass = this.byPassURLs.some((url) => req.url.includes(url));

    if (!shouldBypass) {
      this.incrementRequestCounter();
    }

    return next.handle(clonedReq).pipe(

      map((event) => event),

      catchError((error: HttpErrorResponse) => {

        if (error.status === 401 || error.status === 403) {
          this.storage.clearAll();
          this.backToLogin(
            error?.error?.Message != null ? error.error.Message : error.message
          );
        }

        return throwError(() => error);

      }),

      finalize(() => {

        if (!shouldBypass) {
          this.decrementRequestCounter();
        }

      })
    );
  }

  private incrementRequestCounter(): void {
    this.activeRequests++;

    if (this.activeRequests === 1) {
      this.spinner.show();
    }
  }

  private decrementRequestCounter(): void {
    this.activeRequests--;

    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.spinner.hide();
    }
  }

  private backToLogin(msg = 'Your session has expired') {

    this.authService.logout();
    this.router.navigate(['/login']);

    if (msg) {
      this.toastr.warning(msg);
    }
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];